export default __webpack_public_path__ + "static/media/file-text.802eba41.svg";